import React from 'react';
const MarketContext = React.createContext(null);
export default MarketContext;
//# sourceMappingURL=market.js.map